import { BrandingConfig } from '@/models/BrandingConfig';

export const DATE_TIME_FORMAT = 'Do MMMM YYYY @ HH:mm';

export const DEFAULT_BRANDING_CONFIG: BrandingConfig = {
  productName: 'Netmaker',
  logoDarkUrl: '/logo-dark.png',
  logoLightUrl: '/logo-light.png',
  logoDarkSmallUrl: '/logo-small-dark.png',
  logoLightSmallUrl: '/logo-small-light.png',
  logoAltText: 'Netmaker logo',
  favicon: '/favicon.ico',
};
